import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { PqrSmartHistory } from '../../../../../../shared/types/modules/pqr';
import { TableTooltip } from '../../../../../components/general/table';
import { asyncGetPqrSmartHistory } from '../../../../../../services/pqr.service';
import { PqrSmartHistoryProps } from './props';
import DateTimeFormat from '../../../../../components/dateTimeFormat';

export const usePqrSmartHistory = ({ pqrId }: PqrSmartHistoryProps) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<PqrSmartHistory[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<PqrSmartHistory>[] = [
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        },
        {
            field: 'result',
            headerName: 'Resultado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={JSON.stringify(
                        row.row.result?.res?.message ||
                            row.row.result?.data ||
                            row.row.result
                    )}
                />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Creado por',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.createdBy?.username || ''} />
            ),
        },
    ];

    useEffect(() => {
        setLoading(true);
        asyncGetPqrSmartHistory(pqrId, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [pqrId, page, pageSize]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
